import React, { useContext, } from 'react';
import { Modal } from '../../UI/Modal/Modal.component';
import { Space, Typography, Row, Button, Divider, Form, Input,  } from 'antd';
import { ExclamationCircleOutlined, DeleteOutlined, SaveOutlined,} from '@ant-design/icons';
import { Card } from '../../UI/Card/Card.component';
import { StationContext } from '../../../context/station-context';
import { GROUPED_DEVICES } from '../Station/Devices/DevicesList/DevicesList.component';

const { Paragraph, } = Typography;

export const PendingChangesModal = ({station, title, icon, message, iconColor, setPendingState, updateAll, displayModal, setDisplayModal, ...props}) => {

    const [stationState, dispatchStation] = useContext(StationContext)
    const { pendingQueue, } = stationState;
    
    const displayDevicesPending = () => {
        let devicesPendingElements = [];
        pendingQueue?.forEach(((device, i) => {
                let deviceType;
                let serialNum; 
                if (device.deviceType) {
                    deviceType = device.deviceType;
                    serialNum = `#${device.serialNum}`;
                } else if (!device.deviceType && device.macAddr) {
                    deviceType = 'MAC';
                    serialNum = device.macAddr;
                } 
                devicesPendingElements.push(<p key={i} style={{display: 'block', margin: 0, }}>{deviceType} {serialNum}</p>)
            }
        ))
        return devicesPendingElements;
    }

    const alertMessage = (
        <>
            <Card bordered style={{backgroundColor: 'var(--gray-3)', maxHeight: 200, padding: '10px 20px', margin: '12px 0', marginBottom: 20, textAlign: 'center' }}>
                <code><strong>Station: {station} <br/> Devices modified: {displayDevicesPending().length} </strong></code>
                <Divider style={{margin: '8px auto', minWidth: 0, width: '50%'}}/>
                <code>{displayDevicesPending()}</code>
            </Card>
        </>
    )

    const discardChanges = () => {
        pendingQueue.forEach((pendingDevice) => { 
            let formName = document.getElementById(`${pendingDevice?.deviceType}-${pendingDevice?.id}-device-form`);
            formName?.reset();
        })

        dispatchStation({
            type: 'CLEAR_PENDING_QUEUE'
        })
        setDisplayModal(false);
        setPendingState(false);
    }

    const onFinishUpdateAll = () => {
        props.saveAllPendingChanges()
        setDisplayModal(false);
    }

    const updateAllContent = (
        <>
            { alertMessage }
            <Paragraph style={{textAlign: 'center'}}>You're about to save <strong>ALL</strong> pending changes. Please type <strong>"UPDATE"</strong> to confirm: </Paragraph>
            <Form
                name='savePendingChangesForm'
                autoComplete='off'
                layout='vertical'
                preserve={false}
                onFinish={() => {onFinishUpdateAll()}}
                >
                <Form.Item 
                    name='save-pending'
                    rules={[
                        {
                            required: true,
                            validateTrigger: 'onSubmit',
                            validator: (_, value) => {
                                if(value === 'UPDATE'){
                                    return Promise.resolve();
                                }
                                return Promise.reject(new Error('Please enter "UPDATE" if you want to save.'));
                                }
                            }
                        ]}
                    >
                    <Input style={{textAlign: 'center', }} onInput={(e) => e.target.value = e.target.value.toUpperCase()}/>
                </Form.Item>
                <Row justify='end'>
                    <Form.Item>
                        <Space direction='vertical' align='end'>
                            <Space>
                                <Button onClick={() => stayOnScreen()}>Cancel</Button>
                                <Button htmlType='submit' type='primary' danger icon={<SaveOutlined/>}>Save ALL Changes</Button>
                            </Space>
                        </Space>
                    </Form.Item>
                </Row>
            </Form>
        </>
    );

    const stayOnScreen = () => {
        if(props.setUpdateAll) {
            props.setUpdateAll(false);
        } 
        setDisplayModal(false);
    }

    return(
        <>
            <Modal
                icon={icon || <ExclamationCircleOutlined/>}
                color={iconColor || 'var(--warning-color)'}
                title={title || 'Pending Changes'}
                justifyTitle="middle"
                visible={displayModal}
                setVisible={setDisplayModal}
                actionGroup={false}
                closable={false}
            >

            {/* { !updateAll ? 
                    <>
                        <Paragraph style={{textAlign: 'center'}}>Leaving this page will discard any changes you've made. Do you want to proceed?</Paragraph>
                        { alertMessage }
                        <Row justify='end'>
                            <Space>
                                <Button onClick={() => stayOnScreen()}>Cancel</Button>
                                <Button onClick={() => discardChanges()} danger icon={<DeleteOutlined/>}>Discard changes</Button>
                            </Space>
                        </Row>
                    </>
                : 
                    updateAllContent
                } */}

                <Paragraph style={{textAlign: 'center'}}>{message || "Leaving this page will discard any changes you've made. Do you want to proceed?"}</Paragraph>
                { alertMessage }
                <Row justify='end'>
                    <Space>
                        <Button onClick={() => stayOnScreen()}>Cancel</Button>
                        <Button onClick={() => discardChanges()} danger icon={<DeleteOutlined/>}>Discard changes</Button>
                    </Space>
                </Row>
            </Modal>     
        </>
    )
};

PendingChangesModal.defaultProps = {
    updateAll: false,
}